import { memo, useCallback } from 'react';

import { CheckIcon } from '@air/design-icons';

import {
  workspaceAgentChoiceChip,
  workspaceAgentChoiceChipMark,
} from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentChoiceChip';
import { keepWorkspaceAgentDockFocusOnPointer } from '~/components/v2/components/workspace/workspace-agent-panel/utils/keepWorkspaceAgentDockFocusOnPointer';

export type WorkspaceAgentSelectCheckboxChipProps = {
  index: number;
  label: string;
  onOptionClick: (index: number) => void;
  selected: boolean;
};

/** A pick-several option: checkbox, then a one-line label. */
export const WorkspaceAgentSelectCheckboxChip = memo(
  ({ index, label, onOptionClick, selected }: WorkspaceAgentSelectCheckboxChipProps) => {
    const handleClick = useCallback(() => {
      onOptionClick(index);
    }, [index, onOptionClick]);

    return (
      <button
        aria-pressed={selected}
        className={workspaceAgentChoiceChip({ selected, shape: 'pill' })}
        data-option-index={index}
        data-testid="WORKSPACE_AGENT_SELECT_OPTION"
        onClick={handleClick}
        onMouseDown={keepWorkspaceAgentDockFocusOnPointer}
        title={label}
        type="button"
      >
        <span aria-hidden className={workspaceAgentChoiceChipMark({ checked: selected })}>
          {selected ? <CheckIcon className="size-2" /> : null}
        </span>
        <span className="min-w-0 truncate">{label}</span>
      </button>
    );
  },
);

WorkspaceAgentSelectCheckboxChip.displayName = 'WorkspaceAgentSelectCheckboxChip';
